/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, type FC, useEffect } from "react";
import Pagination from "./Pagination";

export interface LGBPaginationProps {
  maxPerPage: number;
  list: any[]; //Doesn't matter which type it is, as we only split it and return the new list corresponding to the page number
  updateList?: (list: any[]) => void;
}

export const LGBPagination: FC<LGBPaginationProps> = (props) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Når listen endres, tilbakestill til første side
  useEffect(() => {
    setCurrentPage(1);
    // Oppdater listen med første side
    if (props.updateList) {
      const initialList = props.list.slice(0, props.maxPerPage);
      props.updateList(initialList);
    }
  }, [props.list]);

  /**
   * Slices the list and emits the items corresponding to the new page number, and
   * updates the page number.
   * @param page new page number
   */
  function update(page: number) {
    setCurrentPage(page);
    const newList = props.list.slice(
      (page - 1) * props.maxPerPage,
      page * props.maxPerPage,
    );
    return props.updateList ? props.updateList(newList) : null;
  }

  // Beregn totalt antall sider
  const totalPages = props.list.length > props.maxPerPage
    ? Math.ceil(props.list.length / props.maxPerPage)
    : 1;

  // Hvis det ikke er noen elementer eller bare én side, ikke vis paginering
  if (props.list.length <= props.maxPerPage) return null;

  return (
    <div className="mt-2">
      <Pagination
        className="mb-2"
        currentPage={currentPage}
        onPageChange={(page: number) => update(page)}
        totalPages={totalPages}
      />
    </div>
  );
};
